module.exports = __webpack_public_path__ + "img/placeholder.31e421e6.png";